import { ISliderSettings } from '@estee/elc-slider';

export const sliderImageSettings: ISliderSettings = {
    dots: false,
    arrows: true,
    slidesToShow: 1.33,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
        {
            breakpoint: 380,
            settings: {
                slidesToShow: 1.66,
                slidesToScroll: 1,
                arrows: true
            }
        }
    ],
    lazyload: true
};
export const sliderTextSettings: ISliderSettings = {
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    lazyload: true,
    responsive: [
        {
            breakpoint: 319,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
            }
        }
    ]
};
